import 'react-multi-carousel/lib/styles.css';

import Carousel from 'react-multi-carousel';
import CommonService from '../../../../services/commonService';
import MultiSlideType1 from './MultiSlideType1';
import React from 'react';
import { setOperatorSite } from '../../../home/redux/setOperatorSite';

const responsive = {
	superLargeDesktop: {
		// the naming can be any, depends on you.
		breakpoint: { max: 4000, min: 3000 },
		items: 4,
	},
	desktop: {
		breakpoint: { max: 3000, min: 1024 },
		items: 4,
	},
	tablet: {
		breakpoint: { max: 1024, min: 464 },
		items: 2,
	},
	mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 1,
	},
};

const MultiSlider = props => {
	const operator = CommonService.getLocal('op');
	const isExpresoNorto = operator.operator_name === 'expressonorte';

	return (
		<div className="multi-slider-container-outer">
			{isExpresoNorto && (
				<style>
					.react-multi-carousel-list {'{'}
					min-height: 400px !important;
					{'}'}
					.multi-slide-type-1 .image-container {'{'}
					height: 338px !important;
					{'}'}
					.react-multi-carousel-item {'{'}
					padding: 0 10px !important;
					{'}'}
				</style>
			)}

			{props.expressoDotStyle && (
				<style>
					.react-multi-carousel-dot button {'{'}
					{/* width: 33px; height: 10px; border-radius: 5px; background:grey */}
					{'}'}
					.react-multi-carousel-dot--active button {'{'}
					background:white;
					{'}'}
				</style>
			)}

			<div>
				{props.smallHeading && (
					<div className="font10 less-bold-text mb5">{props.smallHeading}</div>
				)}

				{props.boldHeading && (
					<div className="font13 bold-text mb5 black-text-color">{props.boldHeading}</div>
				)}
			</div>
			<div
				className="multi-slider-container"
			>
				<Carousel
					responsive={responsive}
					swipeable={false}
					draggable={false}
					showDots={true}
					infinite={true}
					autoPlay={true}
					autoPlaySpeed={3000}
					customTransition="all .5"
					transitionDuration={3000}
					removeArrowOnDeviceType={['desktop', 'tablet', 'mobile']}
				>
					{props.multiSlides &&
						(props.multiSlides.length || []) > 0 &&
						props.multiSlides.map((slide, index) => {
							return props.slideType === 1 ? (
								<MultiSlideType1 slide={slide} itemNo={index} />
							) : (
								<MultiSlideType1 slide={slide} itemNo={index} />
							);
						})}

				</Carousel>
			</div>
		</div>
	);
};

export default MultiSlider;



// WEBPACK FOOTER //
// ./src/features/themes/common/MultiSlider/MultiSlider.js